import { IconButton, Tooltip, HStack } from '@chakra-ui/react';
import { FiCheck, FiX, FiSend } from 'react-icons/fi';
import { ORG_ADMIN_ONLY_TOOLTIP } from 'services/firebaseAccountLookup';

export const AcceptInviteButtons = (props: {
  invitationId: string;
  partnerId: string;
  status: string;
  onInvitationResponse: (invitationId: string, response: string) => void;
  onPartnerDisconnect: (partnerId: string) => void;
  onCancelInvite: (invitationId: string) => void;
  onInvitePartner: (partnerId: string) => void;
  /** When true, disables incoming invite accept/decline and partner disconnect. */
  disableAdminPartnerActions?: boolean;
}) => {
  const {
    invitationId,
    partnerId,
    status,
    onInvitationResponse,
    onPartnerDisconnect,
    onCancelInvite,
    onInvitePartner,
    disableAdminPartnerActions = false,
  } = props;

  return (
    <HStack spacing={2}>
      {status === 'accepted' && (
        <Tooltip
          label={disableAdminPartnerActions ? ORG_ADMIN_ONLY_TOOLTIP : 'Disconnect'}
          placement="top"
          openDelay={1000}
          shouldWrapChildren
        >
          <IconButton
            aria-label="Disconnect"
            icon={<FiX />}
            size="sm"
            variant="ghost"
            bg="red.100"
            color="red.500"
            isDisabled={disableAdminPartnerActions}
            onClick={() => onPartnerDisconnect(partnerId)}
            _hover={{ color: 'red.600', bg: 'red.50' }}
          />
        </Tooltip>
      )}
      {status === 'requested' && (
        <Tooltip label="Cancel" placement="top" openDelay={1000}>
          <IconButton
            aria-label="Cancel"
            icon={<FiX />}
            size="sm"
            bg="red.100"
            color="red.500"
            variant="ghost"
            onClick={() => onCancelInvite(invitationId)}
            _hover={{ color: 'red.600', bg: 'red.50' }}
          />
        </Tooltip>
      )}
      {status === 'declined' && (
        <Tooltip label="Request" placement="top" openDelay={1000}>
          <IconButton
            aria-label="Request"
            icon={<FiSend />}
            size="sm"
            variant="ghost"
            bg="purple.100"
            color="purple.500"
            onClick={() => onInvitePartner(partnerId)}
            _hover={{ color: 'purple.600', bg: 'purple.50' }}
          />
        </Tooltip>
      )}
      {status === 'pending' && (
        <>
          <Tooltip
            label={disableAdminPartnerActions ? ORG_ADMIN_ONLY_TOOLTIP : 'Accept'}
            placement="top"
            openDelay={1000}
            shouldWrapChildren
          >
            <IconButton
              aria-label="Accept"
              icon={<FiCheck />}
              size="sm"
              variant="ghost"
              color="green.500"
              bg="green.100"
              isDisabled={disableAdminPartnerActions}
              onClick={() => onInvitationResponse(invitationId, 'accept')}
              _hover={{ color: 'green.600', bg: 'green.50' }}
            />
          </Tooltip>
          <Tooltip
            label={disableAdminPartnerActions ? ORG_ADMIN_ONLY_TOOLTIP : 'Decline'}
            placement="top"
            openDelay={1000}
            shouldWrapChildren
          >
            <IconButton
              aria-label="Decline"
              icon={<FiX />}
              size="sm"
              variant="ghost"
              color="red.500"
              bg="red.100"
              isDisabled={disableAdminPartnerActions}
              onClick={() => onInvitationResponse(invitationId, 'decline')}
              _hover={{ color: 'red.600', bg: 'red.50' }}
            />
          </Tooltip>
        </>
      )}
      {status === 'disconnected' && (
        <Tooltip label="Request" placement="top" openDelay={1000}>
          <IconButton
            aria-label="Request"
            icon={<FiSend />}
            size="sm"
            variant="ghost"
            bg="purple.100"
            color="purple.500"
            onClick={() => onInvitePartner(partnerId)}
            _hover={{ color: 'purple.600', bg: 'purple.50' }}
          />
        </Tooltip>
      )}
    </HStack>
  );
};
